<template>
  <div class="mb-2">
    <div v-if="loading" class="text-xs-center"></div>
    <div
      v-else-if="!url"
      class="text-xs-center pa-2 grey lighten-4"
      style="border-radius: 10px; position: relative"
    >
      <div style="text-align: right">
        <v-btn icon color="primary" small style="margin: 0" @click="handleRefresh">
          <v-icon small>refresh</v-icon>
        </v-btn>
      </div>
      <v-icon x-large>highlight_off</v-icon>
      <div class="caption">Not found {{ type == 'image' ? type : 'video' }}</div>
    </div>
    <template v-else>
      <slot v-bind="{ url, mime_type }"> </slot>
    </template>
  </div>
</template>

<script>
import facebookApi from '@/api/facebook'
import logsApi from '@/api/logs'
export default {
  props: ['value', 'type', 'image_url', 'video_url'],
  data() {
    return {
      loading: true,
      url: '',
      mime_type: null
    }
  },
  async mounted() {
    this.handleRefresh()
  },
  methods: {
    async handleRefresh() {
      this.loading = true

      try {
        let resData = await facebookApi.getAttachments(this.value)
        if (this.type == 'image') {
          if (
            resData &&
            resData.data &&
            resData.data.data &&
            resData.data.data[0] &&
            resData.data.data[0].image_data &&
            resData.data.data[0].image_data.url
          ) {
            if (resData.data.data.length > 0) {
              this.url = resData.data.data.map((item) => {
                return item.image_data.url
              })
            } else {
              this.url = resData.data.data[0].image_data.url
            }
          } else if (this.image_url) {
            this.url = this.image_url
          }
        } else {
          if (
            resData &&
            resData.data &&
            resData.data.data &&
            resData.data.data[0] &&
            resData.data.data[0].video_data &&
            resData.data.data[0].video_data.url
          ) {
            this.url = resData.data.data[0].video_data.url
            this.mime_type = resData.data.data[0].video_data.mime_type
          } else if (this.video_url) {
            this.url = this.video_url
            this.mime_type = 'video/mp4'
          }
        }
      } catch (error) {
        console.error(error)
        logsApi.postLogs({ error })
        if (this.type == 'image' && this.image_url) {
          this.url = this.image_url
        } else {
          if (this.video_url) {
            this.url = this.video_url
            this.mime_type = 'video/mp4'
          }
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FacebookContent.vue